// src/shared/config.ts
// Shared configuration constants (browser-safe, no Node.js dependencies)

// ============================================================================
// Path Configuration
// ============================================================================

export const SUB_PATH = '';
export const PROJECT_PATH = '';
export const BASE_PATH = `${SUB_PATH}${PROJECT_PATH}`;
export const API_BASE = `${BASE_PATH}/api`;

// ============================================================================
// App Configuration
// ============================================================================

export const APP_CONFIG = {
  name: 'TM Application',
  version: '2.0.0',
  apiTimeout: 30000, // 30 seconds
} as const;

// ============================================================================
// Validation Constants
// ============================================================================

export const VALIDATION = {
  MIN_PASSWORD_LENGTH: 8,
  MAX_USERNAME_LENGTH: 50,
  MAX_EMAIL_LENGTH: 255,
  MAX_SESSION_LIFETIME_HOURS: 24,
  MAX_ACCESS_CODE_LIFETIME_DAYS: 365,
} as const;

// ============================================================================
// Defaults
// ============================================================================

export const DEFAULTS = {
  SYSTEM_USER_ID: 1,
  PAGINATION_LIMIT: 50,
  MAX_SEARCH_RESULTS: 100,
} as const;

// ============================================================================
// Feature Flags (runtime-agnostic)
// ============================================================================

export const FEATURES = {
  AUTH_REQUIRED: true,
  ACCESS_CODES: true,
  AUTO_CLEANUP_SESSIONS: true,
  POPULATE_DEFAULTS: true,
  LOAD_CSV_REFERENCES: false,
} as const;

// ============================================================================
// Userscript Configuration
// ============================================================================

export const USERSCRIPT_CONFIG = {
  VERSION: '2.3',
  DEFAULT_DELAY: 2000,
  DEFAULT_BATCH_SIZE: 10,
  DEFAULT_TIMEOUT: 30000,
  UUID: 'mcidzo3n-whr4-rj0x-01ja-o94af5oi4qgl',
  TEMPLATE_NAME: 'tma-userscript-interface.js',
  DOWNLOAD_ENDPOINT: '/userscript.zip',
  MATCHES: [
    'https://www.linkedin.com/search/results/people/*',
    'https://www.linkedin.com/mynetwork/invitation-manager/received/*',
    'https://www.linkedin.com/mynetwork/invitation-manager/sent/*',
    'https://www.linkedin.com/in/*',
    'https://www.linkedin.com/groups/*/manage/membership/members/*',
    'https://www.linkedin.com/events/**',
  ],
  GRANTS: [
    'GM_getValue',
    'GM_setValue',
    'GM_deleteValue',
    'GM_xmlhttpRequest',
  ],
} as const;

export const USERSCRIPT_DOWNLOAD_ENDPOINT = "/userscript.zip";
export const USERSCRIPT_VERSION = "2.3";
export const USERSCRIPT_TEMPLATE_NAME = "tma-interface.user.js";
export const USERSCRIPT_MATCHES = [
              "https://www.linkedin.com/search/results/people/*",
              "https://www.linkedin.com/mynetwork/invitation-manager/received/*",
              "https://www.linkedin.com/mynetwork/invitation-manager/sent/*",
              "https://www.linkedin.com/in/*",
              "https://www.linkedin.com/groups/*/manage/membership/members/*",
              "https://www.linkedin.com/events/**",
            ];
export const USERSCRIPT_GRANTS = [
              "GM_getValue",
              "GM_setValue",
              "GM_deleteValue",
              "GM_xmlhttpRequest",
            ];
export const USERSCRIPT_UUID = "mcidzo3n-whr4-rj0x-01ja-o94af5oi4qgl";

// ============================================================================
// Database Configuration (browser-safe defaults)
// ============================================================================

export const DATABASE_PRAGMA = {
  journal_mode: 'WAL',
  synchronous: 'NORMAL',
  cache_size: -64000,
  temp_store: 'MEMORY',
  mmap_size: 268435456,
  page_size: 4096,
} as const;